export default __webpack_public_path__ + "static/media/Laying.e665bd6b.svg";